<template>
  <div class="ui-content dashboard">
    <div class="create-new-test">
      
    </div>
    <v-card class="mx-auto normal-card">
      <div class="data-table-section CustomizedTest">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
           </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="dint-1201">
                    {{ item.test_name }}
                </td>
                <td class="dint-120-test">
                  {{ getFormatedDate(item.created_at) }}
                </td>
                <td class="text-center dint-1201">
                  {{ item.subjects }}
                </td>
                <td class="text-center dint-127">
                  {{ item.duration }}
                </td>
                <td class="dint-120">
                  <div class="cursor_click" @click="onPreviewClick(item)">
                    Preview
                  </div>
                </td>
                <td class="dint-120">
                  <div @click="approveTestPopup(item)" class="Schedule">
                    Approve
                  </div>
                </td>
                <!-- <td>
                  <v-btn
                    class="download-btn-cp3"
                    color="transparent"
                    depressed
                    @click="downloadTest(item)"
                  >
                    <v-img
                      width="23px"
                      src="../../../assets/img/download.svg"
                    ></v-img>
                  </v-btn>
                </td>                 -->
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  name: "AssignTest",
  data() {
    return {
      orderBy: {
        field: "created_at",
        order: "DESC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      headers: [
        { text: "Test Name", value: "test_name", class: "dint-150" },
        { text: "Created On", value: "created_at", class: "dint-120-test" },
        {
          text: "Subjects",
          value: "subjects",
          class: "text-center",
          hideSort: true,
        },
        {
          text: "Duration(mins)",
          align: "center",
          value: "duration",
          class: "text-center dint-120",
          hideSort: true,
        },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "dint-120" },
        // { text: "", value: "", type: "blank", class: "dint-120" },
	      ],
      items: [],
      dialog: false,
      cComponent: "components/coordinator/Tests/ScheduleTestPopup",
      status: false,
      alertBoxData: {},
      selectedTest: null,
      modalwidth: "1000px",
      instituteType: "SILVER",
      currentTestName: "",
    };
  },

  mounted() {
    this.getUserDetails();
    if (this.roleIds.ID == this.user.role_id) {
      this.headers.push({
        text: "",
        value: "",
        type: "blank",
        class: "",
      });
    }
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  methods: {
    ...mapActions({
      getTestList: "testStore/getTestList",
      me: "userStore/me",
      updateTestName: "testStore/updateTestName",
      createDuplicateTest: "testStore/createDuplicateTest",
      deleteTestById: "testStore/deleteTestById",
      approveTest: "testStore/approveTest",
    }),
    downloadTest(item) {
		let domainUrl = process.env.VUE_APP_API_URL;
		let token = sessionStorage.getItem("auth_token");
		let url = domainUrl + `/test/download-test/${item.id}?token=${token}`;
		//   alert(url);
		window.open(url, "_blank");
	},
    confirmDeleteTest(item) {
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.alertBoxData = {
        item,
        message: `Are you sure you want to delete the test - ${item.test_name} ?`,
        refId: "deleteTest",
      };
      this.modalwidth = "350px";
      this.status = true;
      this.$forceUpdate();
    },
    getUserDetails() {
    //   this.me()
    //     .then((response) => {
          this.instituteType = this.user.institute_type;
          this.defaultData();
        // })
        // .catch((err) => {});
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: {
            default: {
              page: 1,
              orderBy: this.orderBy,
            },
          },
        };
        this.setRouteDetails(routeDetails);
      }
    },
    defaultData() {
      this.checkSessionData();
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
      }
      this.requestGetTestList();
    },
    onClose(data) {
      this.status = data.status;
      
      if (data.action === "reloadTestList") {
        this.requestGetTestList();
      }
     
	  if (data.action === "yes" && data.refId === "approveTest") {
        this.approveTests(data.item);
      }
    },
    onPreviewClick(test) {
      localStorage.setItem("test", JSON.stringify(test));
	  let routeName = this.$route.name;
      localStorage.setItem("previousRoute", routeName);
      localStorage.setItem("previousPath", this.$route.path);

      this.$router.push({
        name: "preview-test",
        params: {
          test_id: test.id,
          test_institute_id: test.test_institute_id,
        },
      });
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    requestGetTestList() {
      if (this.instituteType == this.types.SILVER) return;
      let reqData = {
        test_types: [4],
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
		isAssigned:true
      };

      this.$root.showLoader = true;
      this.getTestList(reqData)
        .then((response) => {
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.items = response.list.map((l) => {
            l.editTestName = false;
            return l;
          });
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
      }
    },
    onSortChange() {
      this.requestGetTestList();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
   
    TestInfoDialog(item) {
      this.selectedTest = item;
      this.cComponent = "components/coordinator/Tests/InstructionsPopup";
      this.modalwidth = "600px";
      this.status = true;
      this.alertBoxData = { selectedTest: this.selectedTest };
      this.$forceUpdate();
    },
    resetFields() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.totalPages = 1;
    },
	approveTests(tests){
		const data = {
			test_id : tests.id
		}
		this.approveTest(data)
			.then(response=>{
				this.$toasted.success(response.message)
				this.requestGetTestList()
			})
			.catch(err => {
				this.$toasted.error("Error Approving test")

			})
	},
	approveTestPopup(item){
		this.cComponent = "components/coordinator/ConfirmationDialog";
		this.alertBoxData = {
			item,
			message: `Are you sure you want to approve this test?`,
			refId: "approveTest",
			};
		this.modalwidth = "350px";
      	this.status = true;
      	this.$forceUpdate()
	}
  },
};
</script>
